import React, { Component } from "react";
import { withRouterParams } from "../utils/withRouterParams";

import BackgroundLayer from "../components/BackgroundLayer";
import Submenu from "../components/Submenu";
import DashboardWrapper from "../components/DashboardWrapper";

/* Tab-uri */
import Calendar from "../components/echipa/Calendar";
import Players from "../components/echipa/Players";
import Dashboard from "../components/echipa/Dashboard";
import TrainingOverview from "../components/training/TrainingOverview";
import TrainingContainer from "../components/echipa/TrainingContainer";
import TrainingDetails from "../components/training/TrainingDetails"; // adaugă importul
import GameDetails from "../components/game/GameDetails"; // adaugă importul
import AnalyticsPage from  "../components/echipa/AnalyticsPage";
// import Games     from "./Games";

class TeamDashboard extends Component {
  static pageType = "echipa";

  constructor(props) {
    super(props);
    const isPortrait = window.matchMedia("(orientation: portrait)").matches;
    this.state = { orientation: isPortrait ? "portrait" : "landscape" };
  }

  /* ––––– ascultă schimbarea orientării ––––– */
  componentDidMount() {
    this.mq = window.matchMedia("(orientation: portrait)");
    this.mq.addEventListener("change", this.handleOrientationChange);
  }
  componentWillUnmount() {
    this.mq?.removeEventListener("change", this.handleOrientationChange);
  }
  handleOrientationChange = (e) => {
    this.setState({ orientation: e.matches ? "portrait" : "landscape" });
  };

  /* ––––– tab switch ––––– */
  renderActiveView() {
    const params = new URLSearchParams(this.props.location.search);
    const tab = params.get("tab");
    const view = params.get("view");
    
    // if (view === "training-details") {
    //   const trainingId = params.get("id"); // poate fi null
    //   return <TrainingDetails trainingId={trainingId} />;
    // }
    if (view === "training-details") return <TrainingDetails />;
    if (view === "game-details") return <GameDetails />;
    // if (view === "game-details") return <div >teest</div>

    switch (tab) {
      case "dashboard": return <Dashboard />;
      case "calendar": return <Calendar />;
      case "jucatori": return <Players />;
      case "analitycs": return <AnalyticsPage />;
      case "antrenament": return <TrainingContainer />;
      case "antrenamente": return <TrainingOverview />;
      // case "jocuri":       return <Games />;
      default: return <div>Selectează un tab din submenu.</div>;
    }
  }

  /* ––––– render principal ––––– */
  render() {
    const { orientation } = this.state;

    return (
      <div
        id="echipaDashboard"
        className={`layout-center orientation-${orientation}`}
      >
        <BackgroundLayer imgPath="./../images/" isBgVisible={this.props.isBgVisible} />
        <Submenu role="echipa" />
        <DashboardWrapper>{this.renderActiveView()}</DashboardWrapper>
      </div>
    );
  }
}

export default withRouterParams(TeamDashboard);
